import type { SVGProps } from 'react';
import { Ref, forwardRef, memo } from 'react';
const IconImage = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-label="IconImage"
    ref={ref}
    {...props}
  >
    <g clipPath="url(#IconImage__a)">
      <path
        fill="#404040"
        d="M2.349 24A2.42 2.42 0 0 1 0 21.651v-19.3A2.42 2.42 0 0 1 2.349 0h19.3A2.42 2.42 0 0 1 24 2.349v19.3A2.42 2.42 0 0 1 21.651 24zm2.7-5.212h13.962a.51.51 0 0 0 .5-.322.6.6 0 0 0-.048-.611l-3.8-5.115a.6.6 0 0 0-.933.032l-3.828 4.922-2.542-3.507a.61.61 0 0 0-.483-.225.52.52 0 0 0-.45.225l-2.831 3.668a.56.56 0 0 0-.08.611.53.53 0 0 0 .535.322z"
      />
    </g>
    <defs>
      <clipPath id="IconImage__a">
        <rect width={24} height={24} fill="#fff" rx={3} />
      </clipPath>
    </defs>
  </svg>
);
const ForwardRef = /* #__PURE__ */ forwardRef(IconImage);
const Memo = /* #__PURE__ */ memo(ForwardRef);
export default Memo;
